import { Loader2 } from "lucide-react";
import { Skeleton } from "@/components/ui/skeleton";

export const Loader = () => {
  return (
    <div className="relative flex h-full w-full items-center justify-center bg-background">
      <Skeleton className="h-full w-full" />
      <div className="absolute flex flex-col items-center gap-2">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
        <p className="font-medium text-muted-foreground">Loading...</p>
      </div>
    </div>
  );
};
